import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import PaginationBar from "../../../../components/PaginationBar";
import {useIntl} from "react-intl";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import SearchCondition from "./components/SearchCondition";
import SearchResult from "./components/SearchResult";
import VisitorBlackDetailDialog from "./components/VisitorBlackDetailDialog";
import {VisitorBlackListSearchCondition} from "../../../../modules/vms/dto/VisitorBlackListSearchCondition";
import {VisitorBlackListDto} from "../../../../modules/vms/dto/VisitorBlackListDto";
import {VisitorBlackListApi} from "../../../../modules/vms/api/VisitorBlackListApi";
import {DictItemDto} from "../../../../modules/dict/dto/DictItemDto";
import {DictClassCode} from "../../../../modules/vms/constants/DictClassCode";
import {DictClassApi} from "../../../../modules/dict/api/DictClassApi";
import {Paper} from "@mui/material";
import {MessageUtils} from "../../../../utils/MessageUtils";

const Index: React.FC = () => {

    const intl = useIntl();

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new VisitorBlackListSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<VisitorBlackListDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [currentRow, setCurrentRow] = useState<VisitorBlackListDto>(new VisitorBlackListDto());

    // 访问目的
    const [idTypes, setIdTypes] = useState(new Array<DictItemDto>());

    useEffect(() => {
        // 查询访问目的字典项
        fetchDictClassList();
        handleSearch(searchCondition)
    }, []);

    const fetchDictClassList = async () => {
        const codes = new Array<string>(DictClassCode.VMS_ID_TYPE);
        const responseResult = await DictClassApi.getDictClassList(codes);
        if (responseResult.status === HttpStatus.SUCCESS) {
            for (let dictClass of responseResult.data) {
                switch (dictClass.code) {
                    case DictClassCode.VMS_ID_TYPE:
                        setIdTypes(dictClass.dictItems);
                        break;
                }
            }
        }
    };

    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const handleSearch = async (searchCondition: VisitorBlackListSearchCondition) => {
        const responseResult = await VisitorBlackListApi.queryVisitorBlacks(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const handleModify = async (record: VisitorBlackListDto) => {
        const responseResult = await VisitorBlackListApi.getVisitorBlackDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailModal(true);
        }
    };

    const handleDelete = async (record: VisitorBlackListDto) => {
        const responseResult = await VisitorBlackListApi.deleteVisitorBlack(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
            handleSearch(searchCondition);
        }
    };

    const handleAdd = () => {
        setCurrentRow(new VisitorBlackListDto());
        setOpenDetailModal(true);
    };

    const handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        handleSearch(newSearchCondition);
    };

    return (
        <div>
            <VisitorBlackDetailDialog open={openDetailModal}
                                      visitorBlack={currentRow}
                                      idTypes={idTypes}
                                      onClose={() => setOpenDetailModal(false)}
                                      onOk={() => handleSearch(searchCondition)}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={handleChangeCondition}
                                 onSearch={() => handleSearch(searchCondition)}
                                 onAdd={handleAdd}/>
            </Paper>

            <br/>

            <Paper sx={{p: 1}}>
                <PaginationBar pagination={pagination} onChange={handlePagination}/>
                <SearchResult searchResult={searchResult}
                              onDelete={(record) => handleDelete(record)}
                              onModify={(record) => handleModify(record)}/>
            </Paper>
        </div>
    );
};

export default Index;
